// source: pbtypes/gen/cellular_sim_configs/band.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.cellular_sim_configs.Band', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cellular_sim_configs.Band = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cellular_sim_configs.Band, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cellular_sim_configs.Band.displayName = 'proto.cellular_sim_configs.Band';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cellular_sim_configs.Band.prototype.toObject = function(opt_includeInstance) {
  return proto.cellular_sim_configs.Band.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cellular_sim_configs.Band} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.Band.toObject = function(includeInstance, msg) {
  var f, obj = {
lte164: jspb.Message.getFieldWithDefault(msg, 1, ""),
lte65128: jspb.Message.getFieldWithDefault(msg, 2, ""),
nsa164: jspb.Message.getFieldWithDefault(msg, 3, ""),
nsa65128: jspb.Message.getFieldWithDefault(msg, 4, ""),
sa164: jspb.Message.getFieldWithDefault(msg, 5, ""),
sa65128: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cellular_sim_configs.Band}
 */
proto.cellular_sim_configs.Band.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cellular_sim_configs.Band;
  return proto.cellular_sim_configs.Band.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cellular_sim_configs.Band} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cellular_sim_configs.Band}
 */
proto.cellular_sim_configs.Band.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLte164(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLte65128(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNsa164(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNsa65128(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSa164(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSa65128(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cellular_sim_configs.Band.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cellular_sim_configs.Band.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cellular_sim_configs.Band} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.Band.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLte164();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLte65128();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNsa164();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNsa65128();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSa164();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSa65128();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string lte_1_64 = 1;
 * @return {string}
 */
proto.cellular_sim_configs.Band.prototype.getLte164 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.Band} returns this
 */
proto.cellular_sim_configs.Band.prototype.setLte164 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string lte_65_128 = 2;
 * @return {string}
 */
proto.cellular_sim_configs.Band.prototype.getLte65128 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.Band} returns this
 */
proto.cellular_sim_configs.Band.prototype.setLte65128 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nsa_1_64 = 3;
 * @return {string}
 */
proto.cellular_sim_configs.Band.prototype.getNsa164 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.Band} returns this
 */
proto.cellular_sim_configs.Band.prototype.setNsa164 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string nsa_65_128 = 4;
 * @return {string}
 */
proto.cellular_sim_configs.Band.prototype.getNsa65128 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.Band} returns this
 */
proto.cellular_sim_configs.Band.prototype.setNsa65128 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sa_1_64 = 5;
 * @return {string}
 */
proto.cellular_sim_configs.Band.prototype.getSa164 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.Band} returns this
 */
proto.cellular_sim_configs.Band.prototype.setSa164 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string sa_65_128 = 6;
 * @return {string}
 */
proto.cellular_sim_configs.Band.prototype.getSa65128 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.Band} returns this
 */
proto.cellular_sim_configs.Band.prototype.setSa65128 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.cellular_sim_configs);
